import React, { useEffect } from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { useDeleteAccountGroups } from "@/features/accounts/account-group/hooks/use-delete-account-groups";
import { useAccountGroupsContext } from "@/features/accounts/account-group/contexts/account-groups-context";
import { SimpleForm } from "@/shared/components/text-box/simple-form";


interface Props {
  onTapCloseModal: () => void;
  onTapCompleteModal: () => void;
}

export const DeleteAccountGroupModal = ({ onTapCompleteModal, onTapCloseModal }: Props) => {
  const {
    deleteResult,
    onClickDelete,
    deleteAccountGroups,
  } = useDeleteAccountGroups({ onTapCompleteModal });
  const {
    targetAccountGroup,
  } = useAccountGroupsContext();

  // 初回レンダリング時のみ
  useEffect(() => {
    onClickDelete();
  }, []);

  return (
    <BasePageModal
      handleClose={onTapCloseModal}
      title="グループの削除"
      className="md-group-delete"
      bottomChildren={
        deleteResult === 5 ? (
          <>
          <BaseRoundButton
            buttonText="はい"
            onClick={() => deleteAccountGroups(targetAccountGroup.accountGroupId)}
          />
          <BaseRoundButton
            buttonText="いいえ"
            onClick={onTapCloseModal}
          />
          </>
        ):(
          <BaseRoundButton
            buttonText="閉じる"
            onClick={onTapCloseModal}
          />
        )
      }
    >
      <>
        {deleteResult === 1 && (
        <h2>
        全てのグループを削除することはできません
        </h2>
        )}
        {deleteResult === 4 && (
        <h2>
        共有されているグループ以外の全てのグループを削除することはできません
        </h2>
        )}
        {deleteResult === 2 && (
        <>
        <h2>明細帳が設定されているグループは削除できません</h2>
        <div className="message">
          <p>このグループに設定されている明細帳を全て削除するか別のグループに移した後にグループの削除を行ってください。</p>
        </div>
        </>
        )}
        {deleteResult === 5 && (
        <h2>
        グループを削除します。よろしいですか？
        </h2>
        )}
        {deleteResult === 3 && (
        <h2>
        グループを削除しました
        </h2>
        )}
        <dl>
          <SimpleForm
            id="accountGroupName"
            value={targetAccountGroup.accountGroupsName}
            isReadOnly={true}
            title="グループ名"
            onChange={() => {}}
            labelEnable={true}
            descriptionType={true}
          />
        </dl>
      </>
    </BasePageModal>
  );
};
